import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { useCurrentJobId } from "@/hooks/useCurrentJobId";
import { guacHttpClient } from "@/lib/http";
import {
  CreateVoiceAIOutreachRequest,
  HttpResponse,
  VoiceAIOutreach,
} from "@/types";

export function useCreateVoiceAIOutreach({
  currentCandidacyId,
}: {
  currentCandidacyId: string;
}) {
  const currentCompanyId = useCurrentCompanyId();
  const currentJobId = useCurrentJobId();
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: async ({
      createVoiceAIOutreachRequest,
    }: {
      createVoiceAIOutreachRequest: CreateVoiceAIOutreachRequest;
    }) => {
      const path = `companies/${currentCompanyId}/jobs/${currentJobId}/candidacies/${currentCandidacyId}/voice-ai-outreaches`;
      const res = await guacHttpClient.post<
        VoiceAIOutreach,
        HttpResponse<VoiceAIOutreach>,
        CreateVoiceAIOutreachRequest
      >(path, createVoiceAIOutreachRequest);

      return res.data;
    },
    // The AI Calls header reads this list to decide whether a call is
    // pending, so it has to refetch as soon as one is booked.
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: [
          "voice-ai-outreaches",
          currentCompanyId,
          currentJobId,
          currentCandidacyId,
        ],
      });
    },
  });

  return mutation;
}
